import type { EntryContext, SectionKey } from './types'

// Ratings always lead, stats second — the card is a scouting cheat-sheet, so
// the ratings are the headline regardless of where you opened it from (UI
// review 2026-06-11 #23). `entry` is retained for signature stability but no
// longer flips the order.
export function sectionOrder(_entry: EntryContext): SectionKey[] {
  return ['ratings', 'stats']
}
